export default __webpack_public_path__ + "static/media/PatientLoginIllustration.eb116ef0.svg";